import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { togglePinnedFiltersState, selectContractsPinnedFilters } from '@store';
import { CONTRACTS_FIELDS_MAPPER } from 'components/subscriptionContracts/constants';
import { omit } from 'lodash-es';

export const useContractsFilterConfig = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectContractsPinnedFilters);

  const filterCategories = useMemo(
    () => [
      {
        id: 'status',
        label: 'Status',
        icon: RadioButtonUncheckedIcon,
        options: CONTRACTS_FIELDS_MAPPER.status.options,
        multiSelect: false,
      },
      {
        id: 'createdAt',
        label: 'Created At',
        icon: RadioButtonUncheckedIcon,
        type: 'dateTimeRange',
      },
    ],
    []
  );

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(
      togglePinnedFiltersState({
        board: 'subscriptionContracts',
        pinnedFilter,
      })
    );
  };

  const hasFilters =
    pinnedFilters?.length > 0 ||
    Object.keys(
      omit(router.query, ['page', 'pageSize', 'order', 'orderBy', 'query'])
    ).length > 0;

  const currentFilters = useMemo(
    () => ({
      status: router.query.status || '',
      createdAt: {
        dateFrom: router.query.dateFrom || null,
        dateTo: router.query.dateTo || null,
      },
    }),
    [router.query]
  );

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
  };
};
